// NOTICE: KAPTION-INTEGRATION
import ApiClient from './ApiClient';

class DashboardAppsAPI extends ApiClient {
  constructor() {
    super('dashboard_apps', { accountScoped: true });
  }

  fetchToken(dashboardAppId) {
    return this.show(`${dashboardAppId}/token`);
  }

  // NOTICE: KAPTION-INTEGRATION - Per-app secret support
  regenerateSecret(dashboardAppId) {
    return this.post(`${dashboardAppId}/regenerate_secret`);
  }

  // NOTICE: KAPTION-INTEGRATION - Per-app secret support
  fetchSecret(dashboardAppId) {
    return this.show(`${dashboardAppId}/secret`);
  }
}

export default new DashboardAppsAPI();
